export default "__VITE_ASSET__HpEE$mdC__"